@if (formControl) {
  <input
    class="input-texto__field"
    [class.input-texto__field--error]="hasError"
    [id]="id"
    type="text"
    [placeholder]="placeholder"
    [formControl]="formControl"
    [disabled]="disabled"
    (blur)="onBlur()"
  />
}